<script>
export default {
  props: {
    page: {type: Object},
    scale: {type: String},
    setFieldStyle: {type: Function}
  },
  data() {
    return {
      times: 2,
    };
  },
  created() {
    this.viewport = this.page.getViewport({scale: String(this.scale * this.times)});
  },

  computed: {
    canvasAttrs() {
      let {width, height} = this.viewport;
      
      this.pdfWidth = width;
      this.pdfHeight = height;
      this.setFieldStyle(width, height);
      const style = this.canvasStyle;

      return {
        width,
        height,
        style,
        class: 'pdf-page',
        id: 'pdf-preview',
      };
    },

    canvasStyle() {
      const actualSizeWidth = this.pdfWidth;
      const actualSizeHeight = this.pdfHeight;
      const pixelWidth = actualSizeWidth/this.times
      const pixelHeight = actualSizeHeight/this.times
      return `width: ${pixelWidth}px; height: ${pixelHeight}px;`
    },

    actualSizeViewport() {
      return this.viewport.clone({scale: this.scale});
    },
  },
  mounted() {
    this.drawPage();
  },
  beforeDestroy() {
    this.destroyPage(this.page);
  },
  methods: {
    drawPage() {
      if (this.renderTask) return;

      const {viewport} = this;
      const canvasContext = this.$el.getContext('2d');
      const renderContext = {canvasContext, viewport};

      // PDFPageProxy#render
      // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
      this.renderTask = this.page.render(renderContext);
      this.renderTask.promise.
        then(() => this.$emit('rendered', this.page))
        .catch(this.destroyRenderTask);
    },
    destroyPage(page) {
      if (!page) return;

      // PDFPageProxy#_destroy
      // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
      page._destroy();

      // RenderTask#cancel
      // https://mozilla.github.io/pdf.js/api/draft/RenderTask.html
      if (this.renderTask) this.renderTask.cancel();
    },

    destroyRenderTask() {
      if (!this.renderTask) return;

      // RenderTask#cancel
      // https://mozilla.github.io/pdf.js/api/draft/RenderTask.html
      this.renderTask.cancel();
      delete this.renderTask;
    }
    // ...
  },
  /*
  watch: {
    page(page, oldPage) {
      //this.destroyPage(oldPage);
    },
  },
  */
  render(h) {
    const {canvasAttrs: attrs} = this;
    return h('canvas', {attrs});
  }
}
</script>